export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Discovery & Scope',
      description: 'Understanding project requirements and defining clear deliverables',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Planning & Coordination',
      description: 'Detailed scheduling and resource allocation for seamless execution',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '03',
      title: 'On-Site Execution',
      description: 'Professional deployment with attention to detail and quality standards',
      icon: 'ri-tools-line'
    },
    {
      number: '04',
      title: 'Quality Review & Completion',
      description: 'Final verification and documentation to ensure project success',
      icon: 'ri-checkbox-circle-line'
    }
  ];

  return (
    <section id="process-section" className="py-20 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-white mb-16">
          Our Process
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative"
            >
              <div className="bg-zinc-900 rounded-lg p-8 border border-zinc-800 hover:border-orange-500/30 transition-all duration-300 h-full">
                <div className="flex items-center justify-between mb-6">
                  <span className="text-5xl font-bold text-orange-500/20">
                    {step.number}
                  </span>
                  <div className="w-14 h-14 flex items-center justify-center bg-orange-500/10 rounded-lg">
                    <i className={`${step.icon} text-2xl text-orange-500`}></i>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-orange-500/40"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
